import { sendObject } from './handler';

export type SawRestoreTest = { type: 'sawRestoreTest'; id: string };

export const postSawRestoreTest = async (id: string): Promise<void> =>
  sendObject({ type: 'sawRestoreTest', id }, { skipToggleLoading: true });
